import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  token: {
    colorPrimary: '#0077fd',
    colorInfo: '#0077fd',
    colorWarning: '#f26a43',
    colorError: '#e53024',
    sizeStep: 4,
    borderRadius: 8,
    colorPrimaryTextActive: '#0165d5',
    colorLinkHover: '#0165d5',
    boxShadow: '0px 16px 32px -12px rgba(14, 19, 26, 0.1)',
    colorSuccess: '#35b434',
    colorPrimaryHover: '#0165d5',
    colorPrimaryTextHover: '#005dd6',
    colorErrorTextActive: '#c9261a',
    colorErrorHover: '#c9261a',
    colorErrorBorder: '#ffeaea',
    colorErrorTextHover: '#c9261a',
    colorPrimaryBorder: '#e4f0ff',
    colorText: '#111111',
    colorTextSecondary: '#5d5d5d',
    colorTextTertiary: '#5d5d5d',
    colorTextBase: '#111111',
    controlHeight: 36,
    colorBorder: '#eeeeee',
  },
};
